import {
    FetchState,
    PreferencesState,
    UserPreferences
} from "@/shared/types";

import * as BankService from "@/shared/api/bankService";
import * as storeHelper from "@/shared/storeHelper";
import { errorIsStatus } from "@/shared/errorHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialiState: PreferencesState = {
    fetchState: FetchState.Uninitialized,
    usePaperStatements: null
};

export const usePreferencesStore = defineStore("preferences", {
    state: (): PreferencesState => (_.cloneDeep(initialiState)),
    getters: {
        preferencesLoaded: state => state.fetchState === FetchState.Loaded,
        preferencesLoading: state => state.fetchState === FetchState.Loading,
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setUsePaperStatements (usePaperStatements: boolean) {
            this.usePaperStatements = usePaperStatements;
        },
        loadPreferences (): Promise<any> {
            if (this.fetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }

            this.setFetchState(FetchState.Loading);
            return BankService.getPreferences().then(response => {
                this.setUsePaperStatements(response.data.paperStatement);
                this.setFetchState(FetchState.Loaded);
            }).catch(err => {
                if (errorIsStatus(err, 404)) { // recovery
                    this.setUsePaperStatements(true);
                    this.setFetchState(FetchState.Loaded);
                    return Promise.resolve();
                }
                this.setFetchState(FetchState.Uninitialized);
                return storeHelper.handleError({ error: err, rethrow: false });
            });
        },
        setPreferences (userPreferences: UserPreferences): Promise<any> {
            if (this.fetchState !== FetchState.Loaded) {
                return Promise.resolve();
            }

            return BankService.putPreferences(userPreferences).then(response => {
                this.setUsePaperStatements(response.data.paperStatement);
            }).catch(err => {
                return storeHelper.handleError({ error: err, rethrow: true });
            });
        }
    }
});
